import React from "react";
import UserDefinedFieldValueModel from "../../models/UserDefinedFieldValueModel";
import DateControl from "./DateControl";
import DateTimeControl from "./DateTimeControl";
import DecimalControl from "./DecimalControl";
import NumberControl from "./NumberControl";
import SelectListControl from "./SelectListControl";
import SwitchControl from "./SwitchControl";
import TextboxControl from "./TextboxControl";
import { ControlProps, SelectListOption, UdfOption } from "./Types";

export interface UserDefinedFieldControlProps {
    controlProps: ControlProps
    dataTypeId: number
    options?: SelectListOption[] | UdfOption<string>[]
    disabled?: boolean
}

const UserDefinedFieldControl: React.FC<UserDefinedFieldControlProps> = ({ controlProps, dataTypeId, options, disabled }) => {

    switch (dataTypeId) {
        case 2:
            return <NumberControl {...controlProps} disabled={disabled} />;

        case 3:
            return <DecimalControl {...controlProps} disabled={disabled} />;

        case 4:
            return <DateControl {...controlProps} disabled={disabled} />;

        case 5:
            return <DateTimeControl {...controlProps} disabled={disabled} />;

        case 6:
            if (options)
                return <SelectListControl { ...controlProps } disabled={disabled} options={options} />
            else
                return null;

        case 7:
            return <SwitchControl {...controlProps} disabled={disabled} onValue='True' offValue= 'False' />

        default:
            return <TextboxControl {...controlProps} disabled={disabled} />
    }
}
export default UserDefinedFieldControl;